import { Rating } from '@kizi/shared-components';
import React from 'react';

const size = 16;

export interface RatingCompProps {
  value: string;
}

export const RatingComp = ({ value }: RatingCompProps) => {
  return (
    <Rating
      disabled
      iconProps={{ name: 'star', size, fill: 'main.3' }}
      value={Number(value)}
    />
  );
};

export const RatingLeafComp = ({ value }: RatingCompProps) => {
  return (
    <Rating
      disabled
      iconProps={{ name: 'leaf', size, fill: 'supplementary.2' }}
      mb={1}
      value={Number(value)}
    />
  );
};
